import type { IconName } from "@/components/ui/Icon";
import type { ColumnType } from "@/lib/types";

// Single source of truth for the icon shown for a column type. Used by the table
// header AND both detail panels (RowDetailPanel + mobile RowDetailSheet) so they
// can't drift. Most types map to an icon of the same name; these are the
// exceptions (incl. the read-only meta types, whose type names are NOT icons).
export function columnIconName(type: ColumnType): IconName {
  switch (type) {
    case "lead_time":
      return "timeline";
    case "creator":
      return "person";
    case "creator_department":
      return "building";
    case "creator_company":
      return "briefcase";
    default:
      return type as IconName;
  }
}
